import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

export default class SpacesMapsDraftsAreaMapFloorLegacyRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition): void {
    const { floor_id } = transition.to.params as { floor_id?: string };
    const { area_map_id } = this.paramsFor('spaces.maps.drafts.area-map') as { area_map_id?: string };
    if (area_map_id) {
      this.router.replaceWith('spaces.maps.drafts.area-map.show', area_map_id, {
        queryParams: { floor_id },
      });
    } else {
      this.router.replaceWith('spaces.maps.drafts');
    }
  }
}
